import React from 'react';

// Types
import { QuestionTypeType } from 'Shared/types/ReviewFormTemplate.type';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import AdjectivesForPropertyQuestionReview from './AdjectivesForPropertyQuestionReview';
import GifQuestionReview from './GifQuestionReview';
import TextareaQuestionReview from './TextareaQuestionReview';
import RatingQuestionReview from './RatingQuestionReview';
import TitleDescriptionSectionReview from './TitleDescriptionSectionReview';

type Props = {
  question;
  answers;
  formData;
  showHeader?: boolean;
  alternateKey?: string;
  slimVersion?: boolean;
};

const ReviewQuestion = ({ question, answers, formData, alternateKey, slimVersion }: Props) => {
  const questionType = ReviewFormTemplatesHelpers.getQuestionType(question);

  switch (questionType) {
    case QuestionTypeType.ADJECTIVES_FOR_PROPERTY:
    case QuestionTypeType.ADJECTIVES_FOR_PROPERTY_SUMMARY:
      return (
        <AdjectivesForPropertyQuestionReview
          question={question}
          answers={answers}
          alternateKey={alternateKey}
          slimVersion={slimVersion}
        />
      );
    case QuestionTypeType.GIF:
      return (
        <GifQuestionReview
          question={question}
          answers={answers}
          alternateKey={alternateKey}
          slimVersion={slimVersion}
        />
      );
    case QuestionTypeType.HOLISTIC_SUMMARY:
    case QuestionTypeType.TEXTAREA:
      return (
        <TextareaQuestionReview
          question={question}
          answers={answers}
          alternateKey={alternateKey}
          slimVersion={slimVersion}
        />
      );
    case QuestionTypeType.TITLE_DESCRIPTION:
      return <TitleDescriptionSectionReview question={question} />;
    case QuestionTypeType.RATING:
      return (
        <RatingQuestionReview
          question={question}
          answers={answers}
          formData={formData}
          alternateKey={alternateKey}
          slimVersion={slimVersion}
        />
      );
    case QuestionTypeType.RATING_SUMMARY:
      return (
        <RatingQuestionReview
          question={question}
          answers={answers}
          formData={formData}
          alternateKey={alternateKey}
          slimVersion={slimVersion}
          isSummaryQuestion
        />
      );
    default:
      return null;
  }
};

export default ReviewQuestion;
